import { HttpClient } from '../HttpClient';
/**
 * * Get Permissions
 */
export const GetPermissions = async () => {
  try {
    const { data } = await HttpClient.get('/api/rolecenter/permissions');

    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
